import { render } from "./trustDealerListTable.vue?vue&type=template&id=48166594&scoped=true"
import script from "./trustDealerListTable.vue?vue&type=script&lang=js"
export * from "./trustDealerListTable.vue?vue&type=script&lang=js"

import "./trustDealerListTable.vue?vue&type=style&index=0&id=48166594&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48166594"]])

export default __exports__